module.exports = __webpack_public_path__ + "img/Slider3.d00b83a3.svg";